import { http } from '@next-core/brick-http';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var login = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (data, options) {
    return (yield http.post("api/auth/login", data, options)).data;
  });

  return function login(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var logout = options => http.post("api/auth/logout", options);
var checkLogin = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (options) {
    return (yield http.get("api/auth/login", options)).data;
  });

  return function checkLogin(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
var bootstrap = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(function* (params, options) {
    return (yield http.get("api/auth/bootstrap", _objectSpread2(_objectSpread2({}, options), {}, {
      params
    }))).data;
  });

  return function bootstrap(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();
var getAppStoryboard = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(function* (appId, params, options) {
    return (yield http.get("api/auth/bootstrap/".concat(appId), _objectSpread2(_objectSpread2({}, options), {}, {
      params
    }))).data;
  });

  return function getAppStoryboard(_x6, _x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}();

export { bootstrap, checkLogin, getAppStoryboard, login, logout };
//# sourceMappingURL=index.esm.js.map
